module.exports = __webpack_public_path__ + "img/warning.50390e69.svg";